/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_Sc3Inputs */

const en_fc_tut_sc3 = /** @type {(inputs: Fc_Tut_Sc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lift`)
};

/**
* | output |
* | --- |
* | "Lift" |
*
* @param {Fc_Tut_Sc3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_sc3 = /** @type {((inputs?: Fc_Tut_Sc3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_Sc3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_sc3(inputs)
});
export { fc_tut_sc3 as "fc.tut.sc3" }